<form id="payment-form">
	<div id="card-container"></div>
	<button id="card-button" type="button" (click)="handlePaymentMethodSubmission()">Pay {{ amount | studioCurrency }}</button>
</form>
<div id="payment-status-container"></div>
